export default __webpack_public_path__ + "static/media/nomina2024.03f06d81.pdf";